import type { ComponentType } from 'react'
import { type RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { SalesPermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<{ default: ComponentType } | Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importPage()
  const Page =
    'default' in mod && mod.default
      ? mod.default
      : (mod as Record<string, ComponentType>)[exportName]
  if (!Page) {
    throw new Error(`Sales route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(SalesPermissions.access, Page),
  }
}

export const salesRoutes: RouteObject[] = [
  {
    path: 'sales',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/sales-dashboard-page'), 'SalesDashboardPage'),
  },
  {
    path: 'sales/prospects',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/sales-prospects-page'), 'SalesProspectsPage'),
  },
  {
    path: 'sales/prospects/:prospectId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/sales-prospect-detail-page'),
        'SalesProspectDetailPage',
      ),
  },
  {
    path: 'sales/accounts',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/sales-accounts-page'), 'SalesAccountsPage'),
  },
  {
    path: 'sales/cases',
    lazy: () => lazyGuardedRoute(() => import('./pages/sales-cases-page'), 'SalesCasesPage'),
  },
  {
    path: 'sales/cases/:caseId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/sales-case-detail-page'),
        'SalesCaseDetailPage',
      ),
  },
]
